export function getNotas(state) {
  return state.notas;
}






